export const APPLICATION_TYPES = [
  { value: 'ISSUE', label: 'Issue' },
  { value: 'EXTENSION', label: 'Extension' },
  { value: 'RENEWAL', label: 'Renewal' }
];

export const EMPLOYMENT_TYPES = [
  { value: 'PERMANENT', label: 'Permanent' },
  { value: 'CONTRACT', label: 'Contract' }
];

export const STATUS_LABELS = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted (MRO Manager)',
  RETURNED_TO_APPLICANT: 'Returned to applicant',
  ACCEPTED_BY_MRO_MANAGER: 'Accepted by MRO Manager',
  ACCEPTED_BY_MRO_QM: 'Accepted by MRO QM',
  BOARD_FORMED: 'Board formed',
  ASSESSMENT_IN_PROGRESS: 'Assessment in progress',
  ASSESSMENT_COMPLETE: 'Assessment complete',
  ISSUED: 'Authorization issued',
  NOT_ISSUED: 'Not issued',
  CANCELLED: 'Cancelled'
};

export const STATUS_COLORS = {
  DRAFT: 'default',
  SUBMITTED: 'info',
  RETURNED_TO_APPLICANT: 'warning',
  ACCEPTED_BY_MRO_MANAGER: 'info',
  ACCEPTED_BY_MRO_QM: 'info',
  BOARD_FORMED: 'info',
  ASSESSMENT_IN_PROGRESS: 'warning',
  ASSESSMENT_COMPLETE: 'info',
  ISSUED: 'success',
  NOT_ISSUED: 'error',
  CANCELLED: 'default'
};

export const FORM_REFS = {
  application: 'GETS/CM/002B',
  certificate: 'GETS/CM/001C',
  competencyAttach: 'GETS/CM/03'
};

export const AUTH_NUMBER_PREFIX = 'GETS/IA/';

export const BOARD_SEAT_ROLES = ['HEAD', 'MEMBER_1', 'MEMBER_2', 'MEMBER_3'];

export const BOARD_RESULT_OPTIONS = [
  { value: 'SATISFACTORY', label: 'Satisfactory' },
  { value: 'UNSATISFACTORY', label: 'Unsatisfactory' }
];

export const ASSESSMENT_RESULT_OPTIONS = BOARD_RESULT_OPTIONS;
